import React from 'react';
import cx from 'classnames';
import { Button as SButton } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Icon } from '@plone/volto/components';
import ctaArrowSVG from '@package/icons/cta-arrow.svg';
import blankSVG from '@plone/volto/icons/blank.svg';
// import downloadSVG from '@package/icons/download.svg';

const Button = (props) => {
  let classColor = 'site--button-' + props.color;
  const { showIcon, ...otherProps } = props;

  const isFile = props?.item?.['@type'] === 'File';

  let buttonClass = cx({
    'site--button-primary': true,
    'site--button-outline': props.color?.indexOf('outline') >= 0,
    'site--button-icon': showIcon,
    [classColor]: props.color,
    [props.className]: props.className != null,
  });

  return (
    <SButton {...otherProps} color={null} className={buttonClass}>
      <span>{props.children}</span>
      {showIcon && (
        <Icon
          name={isFile ? blankSVG : ctaArrowSVG}
          className={isFile ? 'download-icon' : 'arrow-icon'}
          size="16px"
        />
      )}
    </SButton>
  );
};

PropTypes.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  showIcon: PropTypes.bool,
};

export default Button;
